import {useEffect} from 'react';

import {Center} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';
import {pushAnalyticsEvent} from '@flexinet/analytics-components';
import {signOut} from 'aws-amplify/auth';

export const SignOutPage = () => {
    useEffect(() => {
        // FNP-1685: a resolved signOut() may have started Amplify's own logout
        // navigation, so leave for '/' only after a delay, and only when
        // beforeunload never fired: a slow navigation may not have unloaded the
        // page yet, and assigning location would cancel it (D14c). It also
        // resolves WITHOUT navigating when there is no OAuth session (D14b). A
        // rejection leaves at once rather than sitting on the loader.
        let leaving = false;
        const onLeave = () => {
            leaving = true;
        };
        window.addEventListener('beforeunload', onLeave);

        const doSignOut = async () => {
            try {
                await signOut();
                pushAnalyticsEvent('sign_out');
                setTimeout(() => {
                    if (!leaving) {
                        window.location.href = '/';
                    }
                }, 3000);
            } catch (error) {
                console.error('Sign out did not complete cleanly', error);
                window.location.href = '/';
            }
        };

        doSignOut();
    }, []);

    return (
        <Center>
            <PlatformLoader/>
        </Center>
    );
};
